import { render, staticRenderFns } from "./CreateBusiness.vue?vue&type=template&id=62dc93fc&scoped=true&"
import script from "./CreateBusiness.vue?vue&type=script&lang=ts&"
export * from "./CreateBusiness.vue?vue&type=script&lang=ts&"
import style0 from "./CreateBusiness.vue?vue&type=style&index=0&id=62dc93fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dc93fc",
  null
  
)

export default component.exports